import { Box, Stack, Typography } from '@mui/material';

import { selectExternalInvitationPublic } from '@/domain/external-invitation/external-invitations.selectors';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';

import { FormExternalPublic } from './components/FormExternalPublic';
import { ShowExternalPublicInfos } from './components/ShowExternalPublicInfos';
import { ShowExternalPublicLink } from './components/ShowExternalPublicLink';

export function AssignExternalPublicView({ projectId }: { projectId: number }) {
  const invitationPublic = useAppSelector(selectExternalInvitationPublic);
  return (
    <Stack spacing={2}>
      <Typography sx={{ fontSize: '1.5rem', fontWeight: '900' }}>
        {translate('ExternalAccessPublic.title')}
      </Typography>
      <Box sx={{ py: 4 }}>
        {invitationPublic ? (
          <Stack spacing={2}>
            <ShowExternalPublicLink invitationPublic={invitationPublic} />
            <ShowExternalPublicInfos invitationPublic={invitationPublic} />
          </Stack>
        ) : (
          <FormExternalPublic projectId={projectId} />
        )}
      </Box>
    </Stack>
  );
}
